module.exports = __webpack_public_path__ + "img/pdf-upload.13227182.png";